<template>
  <div>
    <section  class="navbarsection" style="margin-top: -50px;">
      <div class="txtdata">
        <h1  style="padding-top: 200px;"></h1>
      </div>
        <div class="videosection" >
          <div  v-show="pvisvideo === true && pvpictureimage === false ">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.98
                :src="src"
                :poster="poster"
                :class="`thing playercss`"
                :style="`height: 600px;`">
              </video-background>
            </Transition>
          </div>
        
            <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
            </div>
  
            <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
            v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
   
      </div>
      <div class="overlay"></div>
      <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
        <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
      </div>
    </section>


<section class="divcardsection">
  <div class="seven3css">
    <div class="card shadow divcard">
      <div class="quotesdiv"><i class="fa-solid fa-quote-left"></i></div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div v-html="quotestxt"></div>
          </div>
        </div>
   </div>
  </div>
</section>

<div>
  <ThreecardsSection  :allcardsdata="contdata" />
</div>

  <!-- <div class="tabledatacss">
    <IconleftTextright :approachperf="approachperf" :baseimageurl="myPicUrl" />
  </div> -->

<!-- 
  <div>

    <AlGoals :getagoals="agoals" :getgoaldetails="getgldesc" :firstgoal="firstgoal" :firstgoalid="firstgoalid"
    :imagepath="myPicUrl" agoalstheme="agoalscss" @click.prevent="getgoalId($event)" 
    :toptextinfo="commitinfo" :cmitesglinktext="commitesglinktext" :cmesglink="commitesglink" :catnum="cardnum" />
  </div> -->
<!-- 
  <div class="allreports">
    <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
    :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
    :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" :bgimage="bgimage" />
  </div> -->

  </div>
</template>

<script>
import AlGoals from '@/components/AlGoals.vue';
import DataleftCardright from '@/components/DataleftCardright.vue';
import DownloadPdf from '@/components/DownloadPdf.vue';
import IconleftTextright from '@/components/IconleftTextright.vue';
import AllReports from '@/components/AllReports.vue';
import ThreecardsSection from '@/components/ThreecardsSection.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
import axios from 'axios';
require('@/globalDeclare.js');


export default {
  name: 'AboutView',
  components: {
  AlGoals, DataleftCardright, DownloadPdf, AllReports, IconleftTextright, ThreecardsSection
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  // pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  picurl: myUrlPath,

  agoals: [],
  getgldesc: '',
  firstgoal: '',
  firstgoalid: '',

  commitinfo: '',
  commitesglinktext: '',
  commitesglink: '',
  approachperf: [],

  SliderData: [],
  bgimage: '',
  showbg: 'True',
  cardnum: 2,

  reportpresentation: [],
  lastrecordsreportpresent: [],
  myPicUrl: '',
  contdata: []
  }
},
methods: {
  getgoalId(event){
  let goalid = parseInt(event.target.value)
  axios.get(`getagoalid/${goalid}`).then(
  response => { 
  this.getgldesc = response.data[0].gdesc
  this.firstgoalid = response.data[0].gcid
  })
  .catch((error) => {
      console.log(error)
    })
 },
},
mounted() {
this.myPicUrl = myUrlPath
axios.get('allpagespv/approachperformance').then(
    response => {
      this.videoimage = response.data

      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.picurl + this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.picurl + this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.picurl + this.videoimage.pvpanorama1
      this.pvpanorama2 = this.picurl + this.videoimage.pvpanorama2
      this.pvpanorama3 = this.picurl + this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
      console.log(this.src)
  })
  .catch((error) => {
          console.log(error)
        })

  //------------corpgovernance info---------------
  axios.get('getapproachtomanagement/').then(
    response => {
        this.quotestxt = response.data[0].quotestxt
        this.commitinfo = response.data[0].commitinfo
        this.commitesglinktext = response.data[0].commitesglinktext
        this.commitesglink = response.data[0].commitesglink
        // this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })
  //------------Container Section---------------
  axios.get('getallcardsectionsdata/approachperformance').then(
    response => {
        this.contdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })
  //------------all highlights---------------
  axios.get('getallhiglights/approachperformance').then(
    response => {
        this.approachperf = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------all highlights---------------
  axios.get('getallhiglights/approachperformance').then(
    response => {
        this.approachperf = response.data
        
  })
  .catch((error) => {
      console.log(error)
    })
  
    //------------All SDGS list---------------
  axios.get('getsinglegoalslist/').then(
  response => { 
  // this.opdownloaddesc = response.data.opdownloaddesc
  this.agoals = response.data
  })
  .catch((error) => {
      console.log(error)
    }) 

  //------------All SDGS list---------------
  axios.get('getsinglegoalslist/approachperformance').then(
  response => { 
  this.firstgoal = response.data[0].gdesc
  })
  .catch((error) => {
      console.log(error)
    }) 
  
  //------------all sliders(generic)---------------
  axios.get('getallslidersgeneric/approachperformance').then(
    response => {
        this.SliderData = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  //------------Get Reports---------------
  axios.get('reportpresentationlisting/approachperformance').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })

  //------------all sliders(generic)---------------
  axios.get('getbgimage/approachperformance').then(
    response => {
        this.bgimage = response.data[0].bgimageupload
        console.log(this.bgimage)
  })
  .catch((error) => {
      console.log(error)
    })
}
}
</script>

<style scoped>
.fa-quote-left, .fa-quote-right {
  font-size: 80px;
  padding-left: 10px;
  padding-bottom: 30px;
  color: orange;
  position: relative;
  z-index: 1;
}

.quotesdiv {
  text-align: center;
  margin-top: -35px;
}

.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}
.formatrow {
  margin-top: 340px;
  padding-left: 100px;
  padding-right: 100px;
}


.reportpresentcss {
  margin-top: 300px;
}
.divcardsection {
  padding-bottom: 150px;
}
.card {
  padding-left: 20px;
  padding-right: 20px;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
@media only screen and (max-width: 600px) {
  .divcard {
    margin-left: 20px;
    margin-right: 20px;
    padding-bottom: 50px;
    margin-top: 30px;
  }
 
  .allreports {
    margin-top: 200px;
    padding-bottom: 50px;
  }

 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .divcard {
    margin-left: 20px;
    margin-right: 20px;
    padding-bottom: 50px;
    margin-top: 30px;
  }
 
  .allreports {
    margin-top: 200px;
    padding-bottom: 50px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .divcard {
    margin-left: 20px;
    margin-right: 20px;
    padding-bottom: 50px;
    margin-top: 30px;
  }
 
  .allreports {
    margin-top: 200px;
    padding-bottom: 50px;
  }
 }

 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .divcard {
    margin-left: 100px;
    margin-right: 100px;
    padding-bottom: 50px;
  }
 
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {
  .divcard {
    margin-left: 200px;
    width: 70%;
    padding-bottom: 50px;
  }
 
}

  /* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1600px) {

}
</style>
